export default function SvgPlugConnectedIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 256 256"
      {...props}
    >
      <path
        d="M237.66 18.34a8 8 0 00-11.32 0l-52.4 52.41-5.37-5.38a32.05 32.05 0 00-45.26 0L100 88.69l-6.34-6.35a8 8 0 00-11.32 11.32l6.35 6.34-23.32 23.31a32 32 0 000 45.26l5.38 5.37-52.41 52.4a8 8 0 0011.32 11.32l52.4-52.41 5.37 5.38a32 32 0 0045.26 0L156 167.31l6.34 6.35a8 8 0 0011.32-11.32l-6.35-6.34 23.32-23.31a32 32 0 000-45.26l-5.38-5.37 52.41-52.4a8 8 0 000-11.32zm-116.29 161a16 16 0 01-22.62 0l-22.06-22.09a16 16 0 010-22.62L100 111.31 144.69 156zm57.94-57.94L156 144.69 111.31 100l23.32-23.31a16 16 0 0122.62 0l22.06 22a16 16 0 010 22.68zm-90.9-86.87a8 8 0 0115.18-5.06l8 24a8 8 0 01-15.18 5.06zm-64 58.94a8 8 0 0110.12-5.06l24 8a8 8 0 01-5.06 15.18l-24-8a8 8 0 01-5.06-10.12zm207.18 69.06a8 8 0 01-10.12 5.06l-24-8a8 8 0 015.06-15.18l24 8a8 8 0 015.06 10.12zm-64 58.94a8 8 0 01-15.18 5.06l-8-24a8 8 0 0115.18-5.06z"
        fill="currentColor"
      ></path>
    </svg>
  )
}
